import React from 'react';
import {
    Phone as PhoneIcon,
    PhoneDisabled as MissedCallIcon,
    CallMade as OutgoingIcon,
    CallReceived as IncomingIcon,
    Videocam as MeetingIcon,
    VerifiedUser as TrustCheckIcon,
    Close as CloseIcon,
    Check as CheckIcon,
    Pending as PendingIcon,
} from '@mui/icons-material';
import { Chip } from '@mui/material';

import { endpoint } from '../../utils/utils';

// Platform logos served by the API host at /static/. Resolved once per
// module load (endpoint() inspects window.location / env vars).
export const PLATFORM_LOGO_URL = {
    Zoom: `https://${endpoint()}/static/zoom-logo.png`,
    'Microsoft Teams': `https://${endpoint()}/static/msft-teams.png`,
    Teams: `https://${endpoint()}/static/msft-teams.png`,
};

export { formatTimestamp } from '../../utils/datetime';

export const getTypeIcon = (type) => {
    switch (type) {
        case 'incoming':
            return <IncomingIcon color="primary" />;
        case 'outgoing':
            return <OutgoingIcon color="success" />;
        case 'missed':
            return <MissedCallIcon color="error" />;
        case 'meeting':
            return <MeetingIcon color="info" />;
        case 'trust_check':
            return <TrustCheckIcon color="secondary" />;
        default:
            return <PhoneIcon />;
    }
};

export const getMeetingTypeLabel = (type, t) => {
    switch (type) {
        case 0: return t ? t('callLogs.meetingTypePrescheduled') : 'Prescheduled';
        case 1: return t ? t('callLogs.meetingTypeInstant') : 'Instant';
        case 2: return t ? t('callLogs.meetingTypeScheduled') : 'Scheduled';
        case 3: return t ? t('callLogs.meetingTypeRecurringNoFixed') : 'Recurring (No Fixed Time)';
        case 4: return t ? t('callLogs.meetingTypePersonalRoom') : 'Personal Room';
        case 7: return t ? t('callLogs.meetingTypePAC') : 'PAC';
        case 8: return t ? t('callLogs.meetingTypeRecurringFixed') : 'Recurring (Fixed Time)';
        default: return t ? t('callLogs.unknown') : 'Unknown';
    }
};

export const getVerificationStatusChip = (status) => {
    let color = 'default';
    let label = status;

    if (status === 'verified') {
        color = 'success';
    } else if (status === 'unverified') {
        color = 'error';
    } else if (status === 'pending') {
        color = 'warning';
    }

    return (
        <Chip
            size="small"
            color={color}
            label={label.charAt(0).toUpperCase() + label.slice(1)}
            icon={status === 'verified' ? <CheckIcon /> : status === 'unverified' ? <CloseIcon /> : <PendingIcon />}
        />
    );
};

export const getOverallVerificationStatus = (item) => {
    // Explicit verification.status (meetings shaped by the v2 API)
    if (item.verification && item.verification.status) {
        return item.verification.status;
    }

    // Per-participant verification_data (preview/redirect path)
    if (item.participant && item.participant.verification_data) {
        if (typeof item.participant.verification_data === 'object' && item.participant.verification_data.status) {
            return item.participant.verification_data.status;
        } else {
            return 'verified'; // verification_data exists but no status — assume verified
        }
    }

    // Legacy participants[] array (older call-log shape)
    if (item.participants && Array.isArray(item.participants)) {
        if (item.participants.every(p => p.verificationStatus === 'verified')) {
            return 'verified';
        } else if (item.participants.every(p => p.verificationStatus === 'unverified')) {
            return 'unverified';
        } else {
            return 'partial';
        }
    }

    return 'unknown';
};

export const getLogTypeTitle = (callType, t) => {
    switch (callType) {
        case 'meeting':
            return t ? t('callLogs.typeMeeting') : 'Meeting';
        case 'incoming':
            return t ? t('callLogs.typeIncomingCall') : 'Incoming Call';
        case 'outgoing':
            return t ? t('callLogs.typeOutgoingCall') : 'Outgoing Call';
        case 'missed':
            return t ? t('callLogs.typeMissedCall') : 'Missed Call';
        case 'trust_check':
            return t ? t('callLogs.typeTrustCheck') : 'Trust Check';
        default:
            return t ? t('callLogs.typeCall') : 'Call';
    }
};
